module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTypesStates,
      "code": _vm.ExTypesStatesCode,
      "title": "Types and states",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExIcons,
      "code": _vm.ExIconsCode,
      "title": "Icons",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExValidation,
      "code": _vm.ExValidationCode,
      "title": "Validation",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("Automatic HTML5 validation on-blur.")]), _vm._v(" "), _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.2")])]), _vm._v(" "), _c('p', [_vm._v("You can use "), _c('code', [_vm._v("use-html5-validation")]), _vm._v(" prop to disable the default HTML5 validation.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPassword,
      "code": _vm.ExPasswordCode,
      "title": "Password",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can use the "), _c('code', [_vm._v("password-reveal")]), _vm._v(" prop to add a button that reveals password.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSizes,
      "code": _vm.ExSizesCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb57d7a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/input/Input.vue
// module id = 1418
// module chunks = 13